import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { api } from "../api";
import type {
  IListProductsParams,
  IListProductsResponse,
} from "../interfaces/Products/IListProducts";

export const getProducts = async (
  params: IListProductsParams,
  signal?: AbortSignal
) => {
  const { data } = await api.get<IListProductsResponse>("web/product/list", {
    signal,
    params: {
      pageSize: params.page_size,
      page: params.page,
      ...(params.sort_order && {
        sortOrder: params.sort_order,
      }),
      ...(params.order_by && {
        orderBy: params.order_by,
      }),
      ...(params.emphasis !== null && {
        emphasis: params.emphasis,
      }),
      ...(params.organization_id && {
        organizationId: params.organization_id,
      }),
      ...(params.white_label_id && {
        whitelabelId: params.white_label_id,
      }),
    },
  });

  return data;
};

export const useProducts = (params: IListProductsParams) => {
  const {
    page,
    page_size,
    emphasis,
    order_by,
    organization_id,
    sort_order,
    white_label_id,
  } = params;

  return useQuery(
    [
      "Products",
      page,
      page_size,
      emphasis,
      order_by,
      organization_id,
      sort_order,
      white_label_id,
    ],
    ({ signal }) => getProducts(params, signal)
  );
};

export const getInfiniteProducts = async (
  params: IListProductsParams,
  pageParam: number = 1,
  signal?: AbortSignal
) => {
  const { data } = await api.get<IListProductsResponse>("web/product/list", {
    signal,
    params: {
      pageSize: 12,
      page: pageParam,
      ...(params.sort_order && { sortOrder: params.sort_order }),
      ...(params.order_by && { orderBy: params.order_by }),
      ...(params.emphasis !== null && { emphasis: params.emphasis }),
      ...(params.organization_id && { organizationId: params.organization_id }),
      ...(params.white_label_id && { whitelabelId: params.white_label_id }),
      ...(params.subcategory && { subcategory: params.subcategory }),
    },
  });

  return {
    data: data.data,
    nextPage: pageParam + 1,
    hasMore: data.totalElements > data.data.length, // Determina se há mais dados
  };
};
export const useInfiniteProducts = (params: IListProductsParams) => {
  return useInfiniteQuery(
    ["Products", params],
    ({ pageParam = 1, signal }) =>
      getInfiniteProducts(params, pageParam, signal),
    {
      getNextPageParam: (lastPage) =>
        lastPage.hasMore ? lastPage.nextPage : undefined,
    }
  );
};
